import { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import { useMenuItems } from 'hooks/useMenuItems';
import { useBreakpointFlags } from 'hooks/useBreakpointFlags';

import FullScreenLoader from './FullScreenLoader';
import ResponsiveHeader from './ResponsiveHeader';
import MobileMenu from './MobileMenu';
import Sidebar from './Sidebar';

const styles = {
  container: {
    position: 'relative',
  },
};

export const PrivateLayout = ({ children }) => {
  const { isXlDown: shouldRenderMobileMenu } = useBreakpointFlags();

  const {
    isMobileMenuOpen,
    toggleIsMobileMenuOpen,
    setIsMobileMenuOpen,
    accountMenuItems,
    mobileMenuItems,
    sidebarItems,
  } = useMenuItems();

  return (
    <Box sx={styles.container}>
      <ResponsiveHeader
        toggleIsMobileMenuOpen={toggleIsMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        shouldRenderMobileMenu={shouldRenderMobileMenu}
      />

      {shouldRenderMobileMenu ? (
        <MobileMenu
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          menuItems={mobileMenuItems}
          accountMenuItems={accountMenuItems}
        />
      ) : (
        <Sidebar sidebarItems={sidebarItems} />
      )}

      <Suspense fallback={<FullScreenLoader />}>
        <div>{children}</div>
      </Suspense>
    </Box>
  );
};

PrivateLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
